import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 12px 0px;
  div.containerChildren {
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
  }
  @media (min-width: 992px) {
    padding: 70px 0px 0px 88px;
    div.containerChildren {
      padding: 12px 32px;
    }
  }
`;

const ContainerProcedure: React.FC = ({ children }) => (
  <Container>
    <div className="containerChildren">{children}</div>
  </Container>
);

export default ContainerProcedure;
